const isWebSocketEvent = (reason) => {
  if (!reason) return false;

  if (reason instanceof Event) return true;

  if (
    reason &&
    typeof reason === "object" &&
    (reason.isTrusted !== undefined ||
      reason.type === "error" ||
      reason.type === "close") &&
    reason.target &&
    reason.target.url &&
    reason.target.url.includes("tinode")
  ) {
    return true;
  }

  if (String(reason) === "[object Event]") return true;

  return false;
};

const isTinodeNonFatalError = (reason) => {
  if (!reason) return false;

  const msg = reason?.message || reason?.text || String(reason) || "";

  const nonFatalPatterns = [
    "already authenticated",
    "Promise expired",
    "Message rejected",
    "timeout",
    "503",
    "504",
    "no content",
    "204",
  ];

  return nonFatalPatterns.some((p) =>
    msg.toLowerCase().includes(p.toLowerCase()),
  );
};

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;

  if (isWebSocketEvent(reason) || isTinodeNonFatalError(reason)) {
    event.preventDefault();

    if (process.env.NODE_ENV === "development") {
      console.debug(
        "[Tinode] Suppressed non-fatal unhandled rejection:",
        reason?.type || reason?.message || String(reason),
      );
    }
  }
});

window.addEventListener("error", (event) => {
  if (
    event.message &&
    (event.message.includes("tinode") ||
      event.message.includes("WebSocket") ||
      event.message.includes("connection.js"))
  ) {
    if (process.env.NODE_ENV === "development") {
      console.debug("[Tinode] Suppressed window error:", event.message);
    }
  }
});
